const AnnualReturnChart = require('okCharts/AnnualReturnChart');

module.exports = AnnualReturnChart;